var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('div',{staticClass:"loading-overlay"},[_c('img',{attrs:{"src":require("../../../../public/img/icons/loading.gif"),"alt":"Loading"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }